import React from 'react';
import { useGLTF } from '@react-three/drei';
import { Euler, Vector3 } from '@react-three/fiber';

import { GLTFResult, Type } from './types';

const path = "/static/glb/apple.glb";

const Apple = React.forwardRef(({
  type,
  position = [0, 0, 0],
  scale = 2.5,
  rotation = [0, 0, 0]
}: {
  type: Type,
  position?: Vector3,
  scale?: number,
  rotation?: Euler
},
  ref: React.ForwardedRef<THREE.Group>
) => {

  const { nodes, materials } = useGLTF(path) as any as GLTFResult;

  return (
    <group
      ref={ref}
      position={position}
      scale={[scale, scale, scale]}
      rotation={rotation}
    >
      {type === "full" &&
        <>
          <mesh geometry={nodes.Apple_1.geometry} material={nodes.Apple_1.material} />
          <mesh geometry={nodes.Apple_2.geometry} material={materials.Leaf} />
        </>
      }

      {type === "half" &&
        <>
          <mesh geometry={nodes.AppleHalf1_1.geometry} material={nodes.AppleHalf1_1.material} />
          <mesh geometry={nodes.AppleHalf1_2.geometry} material={nodes.AppleHalf1_2.material} />
        </>
      }

      {type === "quarter" &&
        <>
          <mesh geometry={nodes.Apple002.geometry} material={nodes.Apple002.material} />
          <mesh geometry={nodes.Apple002_1.geometry} material={nodes.Apple002_1.material} />
        </>
      }
    </group >
  );
});

useGLTF.preload(path);

export default Apple;